//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UiFocusContainer from './UiFocusContainer.vue';
import UiMenuOption from './UiMenuOption.vue';

export default {
  name: 'UiMenu',

  components: {
    UiFocusContainer,
    UiMenuOption,
  },

  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    hasIcons: {
      type: Boolean,
      default: false,
    },
    iconProps: Object,
    hasSecondaryText: {
      type: Boolean,
      default: false,
    },
    containFocus: {
      type: Boolean,
      default: false,
    },
    keys: {
      type: Object,
      default() {
        return {
          icon: 'icon',
          type: 'type',
          label: 'label',
          secondaryText: 'secondaryText',
          iconProps: 'iconProps',
          disabled: 'disabled',
          href: 'href',
          target: 'target',
        };
      },
    },
    disableRipple: {
      type: Boolean,
      default: false,
    },
    raised: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        'is-raised': this.raised,
        'has-icons': this.hasIcons,
        'has-secondary-text': this.hasSecondaryText,
      };
    },
  },

  methods: {
    selectOption(option) {
      if (option.disabled || option.type === 'divider') {
        return;
      }

      this.$emit('select', option);
      this.closeMenu();
    },

    closeMenu() {
      this.$emit('close');
    },
  },
};

